import { sampleData } from "../../../Routes/RenderPdf/sampleData";
import { seedConfigFromSample } from "../../../Routes/RenderPdf/seedConfig";

export function Default() {
  return {
    baseline: [],
    data: [],
    editable: false,
    isProcessing: false,
    dirty: false,
    saving: false,
    error: null,
    isDataFetched:false,
  };
}
